
import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { Company, Job } from '@/models/job'
import Mixin from '@/mixins'
import CardBlog from '@/components/JobDetail/CardBlog.vue'

@Component({
  name: 'InformationCompany',
  components: {
    CardBlog,
  },
})
export default class InfomationCompany extends mixins(Mixin) {
  @Prop({ required: true, type: Object }) readonly company: Company
  @Prop({ required: false, type: Object }) readonly job: Job
  benefits: any[] = []

  isCollapse: boolean = false

  handleCollapseDetail() {
    this.isCollapse = !this.isCollapse
  }

  mounted() {
    this.benefits = this.company.benefits

    if (this.job && this.job.benefits && this.job.benefits.length > 0) {
      this.benefits = this.job.benefits
    }
  }
}
